import { render, staticRenderFns } from "./BetgameEdit.vue?vue&type=template&id=ef836364&scoped=true"
import script from "./BetgameEdit.vue?vue&type=script&lang=js"
export * from "./BetgameEdit.vue?vue&type=script&lang=js"
import style0 from "./BetgameEdit.vue?vue&type=style&index=0&id=ef836364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef836364",
  null
  
)

export default component.exports